import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, Smartphone, Monitor, Tablet, Cpu } from 'lucide-react';

const categories = [
  {
    icon: Smartphone,
    title: 'Telefon Servisi',
    description: 'iPhone, Samsung, Xiaomi ve tüm markalar',
    href: '/servis',
    color: 'from-blue-500/10 to-blue-600/5',
  },
  {
    icon: Tablet,
    title: 'Tablet Servisi',
    description: 'iPad, Samsung Tab, Xiaomi Pad',
    href: '/servis',
    color: 'from-purple-500/10 to-purple-600/5',
  },
  {
    icon: Monitor,
    title: 'Bilgisayar Servisi',
    description: 'MacBook, Laptop, Masaüstü',
    href: '/servis',
    color: 'from-green-500/10 to-green-600/5',
  },
  {
    icon: Cpu,
    title: 'Anakart Tamiri',
    description: 'Profesyonel mikroçip onarımı',
    href: '/servis',
    color: 'from-cyan-500/10 to-cyan-600/5',
  },
];

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
    },
  },
};

const item = {
  hidden: { opacity: 0, y: 20 },
  show: { opacity: 1, y: 0 },
};

export const CategorySection = () => {
  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 lg:mb-16">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-block text-sm font-medium text-primary uppercase tracking-wider mb-3"
          >
            Servislerimiz
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-3xl sm:text-4xl lg:text-5xl font-bold font-display text-foreground mb-4"
          >
            Hizmet Alanlarımız
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-lg text-muted-foreground max-w-2xl mx-auto"
          >
            Tüm elektronik cihazlarınız için profesyonel teknik servis hizmeti sunuyoruz.
          </motion.p>
        </div>

        {/* Categories Grid */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {categories.map((category) => (
            <motion.div key={category.title} variants={item}>
              <Link
                to={category.href}
                className="group block p-6 rounded-2xl border bg-card hover:shadow-card transition-all duration-300"
              >
                <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${category.color} flex items-center justify-center mb-4`}>
                  <category.icon className="w-7 h-7 text-primary" />
                </div>
                <h3 className="text-xl font-semibold font-display text-foreground mb-2 group-hover:text-primary transition-colors">
                  {category.title}
                </h3>
                <p className="text-muted-foreground mb-4">{category.description}</p>
                <div className="flex items-center text-primary font-medium">
                  <span className="text-sm">Detaylı Bilgi</span>
                  <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default CategorySection;
